import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  border: 0;\n  ", ";\n\n  opacity: 0;\n  padding: 0;\n  width: 100%;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  text-align: center;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 18px;\n  font-weight: ", ";\n  margin-bottom: ", ";\n  text-align: center;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background-image: url(", ");\n  background-position: center top;\n  background-repeat: no-repeat;\n  background-size: 190px 119px;\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  padding-top: 119px;\n\n  @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {\n    background-image: url(", ");\n  }\n\n  @media (-webkit-min-device-pixel-ratio: 3), (min-resolution: 288dpi) {\n    background-image: url(", ");\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  border: 2px dashed ", ";\n  border-radius: ", "px;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import Dropzone from 'react-dropzone';
import styled from 'styled-components';
import { position } from 'polished';
import { color, property, typography } from '@scp/ui-shared/theme/variables';
import { Pictures, Pictures2x, Pictures3x } from '@scp/ui-shared/theme/assets/images';
import { baselineToPx } from '@scp/ui-shared/theme/utils';
var TEXT = {
  TITLE: 'Drag file here',
  MESSAGE_LINE_1: 'Accepted format: jpg, png, gif, pdf, word, ppt',
  MESSAGE_LINE_2: 'Maximum upload size: 20MB',
  MESSAGE_LINE_3: 'Maximum number of files at a time: 10'
};
var OuterWrapper = styled.div(_templateObject(), function (props) {
  return props.isFrameDragActive && !props.disabled ? 'block' : 'none';
});
var Wrapper = styled.div(_templateObject2(), color.textSecondary, property.borderRadius);
var InnerWrapper = styled.div(_templateObject3(), Pictures, Pictures2x, Pictures3x);
var MessageTitle = styled.h2(_templateObject4(), color.textSecondary, typography.fontWeightSemiBold, baselineToPx(2));
var MessageText = styled.p(_templateObject5(), color.textSecondary);
var Input = styled.input(_templateObject6(), position('absolute', 0, 0, 0, 0));
export var DropArea = function DropArea(_ref) {
  var isFrameDragActive = _ref.isFrameDragActive,
      onFileDrop = _ref.onFileDrop,
      className = _ref.className,
      disabled = _ref.disabled;
  return React.createElement(Dropzone, {
    onDrop: onFileDrop,
    disabled: disabled
  }, function (_ref2) {
    var getRootProps = _ref2.getRootProps,
        getInputProps = _ref2.getInputProps;
    return React.createElement(OuterWrapper, Object.assign({}, getRootProps(), {
      className: className,
      isFrameDragActive: isFrameDragActive,
      disabled: disabled
    }), React.createElement(Input, Object.assign({}, getInputProps(), {
      "aria-hidden": "true"
    })), React.createElement(Wrapper, null, React.createElement(InnerWrapper, null, React.createElement(MessageTitle, null, TEXT.TITLE), React.createElement(MessageText, null, TEXT.MESSAGE_LINE_1, React.createElement("br", null), TEXT.MESSAGE_LINE_2, React.createElement("br", null), TEXT.MESSAGE_LINE_3))));
  });
};